import React from 'react';

import { ThemeProvider, useTheme } from '../../../v2/app/theme';
import LoginForm from './LoginForm';

const initial = (process.env.REACT_APP_MERCHANT || 'K').trim()[0].toUpperCase();

export default function LoginBox({ onSubmit }) {
    return (
        <ThemeProvider>
            <LoginBoxInner onSubmit={onSubmit} />
        </ThemeProvider>
    );
}

function LoginBoxInner({ onSubmit }) {
    const { theme } = useTheme();

    return (
        <div className={theme === 'dark' ? 'dark' : ''}>
            <div
                className="v2-root flex min-h-screen min-h-[100dvh] w-full flex-col bg-white dark:bg-gray-950 sm:items-center sm:justify-center sm:bg-gradient-to-br sm:from-indigo-50 sm:via-white sm:to-cyan-50 sm:p-6 sm:dark:from-gray-950 sm:dark:via-gray-900 sm:dark:to-gray-950"
                style={{
                    paddingTop: 'env(safe-area-inset-top)',
                    paddingBottom: 'env(safe-area-inset-bottom)',
                    paddingLeft: 'env(safe-area-inset-left)',
                    paddingRight: 'env(safe-area-inset-right)',
                }}
            >
                <div className="flex w-full flex-1 flex-col justify-center px-5 py-8 sm:max-w-md sm:flex-none sm:rounded-2xl sm:border sm:border-solid sm:border-gray-200 sm:bg-white sm:p-8 sm:shadow-xl sm:dark:border-gray-800 sm:dark:bg-gray-900">
                    <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-cyan-500 text-3xl font-semibold text-white shadow-lg shadow-indigo-500/30 sm:h-14 sm:w-14 sm:text-2xl">
                        {initial}
                    </div>
                    <h1 className="text-3xl font-semibold tracking-tight text-gray-900 dark:text-gray-50 sm:text-2xl">
                        Bun venit
                    </h1>
                    <p className="mb-8 mt-2 text-base text-gray-500 dark:text-gray-400 sm:mb-7 sm:mt-1.5 sm:text-sm">
                        Introdu datele de acces pentru a continua.
                    </p>
                    <LoginForm onSubmit={onSubmit} />
                </div>
            </div>
        </div>
    );
}
